.contentArea {
	flex: 1;
	width: 100%;
	overflow: hidden;
}
